exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dismiss-animation__revealExpandStart__1VXgd {\n  max-height: 0px;\n  opacity: 0.01;\n  transition-property: opacity, max-height;\n  transition-duration: 150ms;\n  transition-timing-function: ease-out, linear;\n}\n.dismiss-animation__revealExpandEnd__3NdPJ {\n  max-height: 300px;\n  opacity: 1;\n}\n.dismiss-animation__fadeCollapseStart__b6oU- {\n  max-height: 300px;\n  opacity: 1;\n  transition-property: opacity, max-height;\n  transition-duration: 200ms;\n  transition-timing-function: ease-out, linear;\n}\n.dismiss-animation__fadeCollapseEnd__23I4g {\n  max-height: 0px;\n  opacity: 0.01;\n}\n", ""]);

// exports
exports.locals = {
	"revealExpandStart": "dismiss-animation__revealExpandStart__1VXgd",
	"revealExpandEnd": "dismiss-animation__revealExpandEnd__3NdPJ",
	"fadeCollapseStart": "dismiss-animation__fadeCollapseStart__b6oU-",
	"fadeCollapseEnd": "dismiss-animation__fadeCollapseEnd__23I4g"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":2,"localIdentName":"[name]__[local]__[hash:base64:5]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-1972/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/dismiss-animation.less
// module id = +sXP
// module chunks = 1